"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseQuery = void 0;
const index_js_1 = require("../../../../attributes/binary/index.js");
const index_js_2 = require("../../../../attributes/index.js");
const index_js_3 = require("../../../../attributes/number/index.js");
const index_js_4 = require("../../../../errors/index.js");
const index_js_5 = require("../../../../schema/actions/parseCondition/index.js");
const index_js_6 = require("../../../../schema/index.js");
const pick_js_1 = require("../../../../utils/pick.js");
const types_js_1 = require("../types.js");
const defaultAttribute = {
    required: 'never',
    key: false,
    hidden: false,
    savedAs: undefined,
    enum: undefined,
    transform: undefined,
    big: false,
    defaults: { key: undefined, put: undefined, update: undefined },
    links: { key: undefined, put: undefined, update: undefined },
    validators: { key: undefined, put: undefined, update: undefined }
};
const getIndexKeySchema = (key) => {
    switch (key.type) {
        case 'number':
            return new index_js_3.NumberAttribute({ ...defaultAttribute, path: key.name });
        case 'string':
            return new index_js_2.StringAttribute({ ...defaultAttribute, path: key.name });
        case 'binary':
            return new index_js_1.BinaryAttribute({ ...defaultAttribute, path: key.name });
    }
};
const parseQuery = (table, query) => {
    const { index, partition, range } = query;
    let primaryKeySchema;
    if (index !== undefined) {
        const indexKeySchema = table.indexes[index];
        if (indexKeySchema === undefined) {
            const indexes = Object.keys(table.indexes);
            const hasIndex = indexes.length > 0;
            throw new index_js_4.DynamoDBToolboxError('queryCommand.invalidIndex', {
                message: `Unknown index: ${index}. ${hasIndex ? ` Expected one of: ${indexes.join(', ')}.` : ''}`,
                payload: { received: index, ...(hasIndex ? { expected: Object.keys(table.indexes) } : {}) }
            });
        }
        primaryKeySchema = indexKeySchema;
    }
    else {
        primaryKeySchema = table;
    }
    const { partitionKey = table.partitionKey, sortKey } = primaryKeySchema;
    if (partition === undefined) {
        throw new index_js_4.DynamoDBToolboxError('queryCommand.invalidPartition', {
            message: `Missing query partition. Expected: ${partitionKey.type}.`,
            path: partitionKey.name,
            payload: { partition }
        });
    }
    const indexSchema = new index_js_6.Schema({});
    indexSchema.attributes[partitionKey.name] = getIndexKeySchema(partitionKey);
    let condition = { attr: partitionKey.name, eq: partition };
    if (sortKey !== undefined && range !== undefined) {
        indexSchema.attributes[sortKey.name] = getIndexKeySchema(sortKey);
        const sortKeyCondition = {
            attr: sortKey.name,
            ...(0, pick_js_1.pick)(range, ...types_js_1.queryOperatorSet)
        };
        condition = { and: [condition, sortKeyCondition] };
    }
    const conditionParser = new index_js_5.ConditionParser(indexSchema, '0');
    conditionParser.parse(condition);
    const { ConditionExpression, ExpressionAttributeNames, ExpressionAttributeValues } = conditionParser.toCommandOptions();
    return {
        KeyConditionExpression: ConditionExpression,
        ExpressionAttributeNames,
        ExpressionAttributeValues
    };
};
exports.parseQuery = parseQuery;
